import { RouteRecordRaw } from 'vue-router';

import {
  useEditTerminalStore,
  useRootStore,
} from '@/store';

// 端末関連
export const terminalRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Terminal',
    component: () => import('@/components/pages/terminal/index.vue'),
    path: '/terminal',
    meta: {
      title: '端末',
      requiredAuthority: 'TERMINALS',
    },
  },
  {
    name: 'TerminalId',
    component: () => import('@/components/pages/terminal/detail/index.vue'),
    path: '/terminal/:id',
    meta: {
      title: '端末詳細',
      requiredAuthority: 'TERMINALS',
    },
  },
  {
    name: 'TerminalEdit',
    component: () => import('@/components/pages/terminal/detail/edit/index.vue'),
    path: '/terminal/:id/edit',
    meta: {
      title: '端末編集',
      requiredAuthority: 'EDIT_TERMINALS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();

      const editTerminalStore = useEditTerminalStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'TerminalEditConfirm') {
        await editTerminalStore.setInitData(id);
        editTerminalStore.$resetForm();
        useRootStore().$reset();
      }
      next();
    },
  },
  {
    name: 'TerminalEditConfirm',
    component: () => import('@/components/pages/terminal/detail/edit/confirm/index.vue'),
    path: '/terminal/:id/edit/confirm',
    meta: {
      title: '端末編集確認',
      requiredAuthority: 'EDIT_TERMINALS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditTerminalStore();
      const {
        form,
        initData,
      } = store;

      if (from.path === `/terminal/${id}/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/terminal/${id}`, replace: true });
      }
    },
  },
];
